import "./Home.module.css";
import UstMenu from "@/reusable_sections/Header";
import WhereBeautyMeetsArt from "./sections/WhereBeautyMeetsArt";
import WhyWorkWithUs from "./sections/WhyWorkWithUs";
import Gallery from "./sections/Gallery";
import OurExpertise from "./sections/OurExpertise";
import ClinicComfortAndTechnology from "./sections/ClinicComfortAndTechnology";
import QuickShuttleBooking from "./sections/QuickShuttleBooking";
import CorporateFooter from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
export default function HomePage() {
  return <div>
      <UstMenu />
      <WhereBeautyMeetsArt />
      <Hero />
      <WhyWorkWithUs />
      <Gallery />
      <OurExpertise />
      <ClinicComfortAndTechnology />
      <QuickShuttleBooking />
      <CorporateFooter />
    </div>;
}